import emarsysEventsService from '@lib/analytics/emarsys/EmarsysEventsService'
import date from '@lib/date'

declare global {
  type PurchaseOrder = {
    orderId: string
    items: CartItem[]
  }
}

const getCommonParams = () => {
  return {
    date: date.formatDateISO(date.today()),
  }
}

const setEmailEvent = (email: string) => {
  emarsysEventsService.push('setEmail', email)
}

const tagEvent = (key: string, params?: any) => {
  emarsysEventsService.push('tag', key, { ...getCommonParams(), ...params })
}

const cartEvent = (items: CartItem[]) => {
  emarsysEventsService.push('cart', items)
}

const purchaseEvent = (order: PurchaseOrder) => {
  // Emarsys batch API expects (orderId, items, total)
  const total = order.items.reduce((sum, it) => sum + it.price * it.quantity, 0)
  emarsysEventsService.push('purchase', order.orderId, order.items, total)
}

export default {
  setEmailEvent,
  tagEvent,
  cartEvent,
  purchaseEvent,
}
